var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisclaimerWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#583F99",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4213 15.9467C19.326 15.2898 19.3731 14.6201 19.5594 13.983C19.7458 13.346 20.067 12.7564 20.5013 12.2545C20.9357 11.7526 21.4729 11.35 22.0766 11.074C22.6803 10.7981 23.3362 10.6553 24 10.6553C24.6638 10.6553 25.3198 10.7981 25.9234 11.074C26.5271 11.35 27.0644 11.7526 27.4987 12.2545C27.933 12.7564 28.2542 13.346 28.4406 13.983C28.6269 14.6201 28.674 15.2898 28.5787 15.9467L27.0427 26.6933C26.9364 27.4244 26.5704 28.0928 26.0116 28.5762C25.4529 29.0595 24.7388 29.3256 24 29.3256C23.2612 29.3256 22.5471 29.0595 21.9884 28.5762C21.4297 28.0928 21.0636 27.4244 20.9573 26.6933L19.4213 15.9467ZM26.6667 34.6667C26.6667 35.3739 26.3857 36.0522 25.8856 36.5523C25.3855 37.0524 24.7072 37.3333 24 37.3333C23.2928 37.3333 22.6145 37.0524 22.1144 36.5523C21.6143 36.0522 21.3333 35.3739 21.3333 34.6667C21.3333 33.9594 21.6143 33.2811 22.1144 32.781C22.6145 32.2809 23.2928 32 24 32C24.7072 32 25.3855 32.2809 25.8856 32.781C26.3857 33.2811 26.6667 33.9594 26.6667 34.6667Z",
    fill: "#583F99"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#583F99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisclaimerWarning);
export default __webpack_public_path__ + "static/media/disclaimerWarning.325480fa4f2265b845f960ed4bdee681.svg";
export { ForwardRef as ReactComponent };